import { Store } from '../types'

export const errorSelector = (store: Store) => store.error
